import React, { useEffect } from 'react'
import createScript from '../../../../../../../utils/create-script'

export default props => {
    const { orderTotal, className } = props
    useEffect(async () => {
        await createScript('zip-wedgit-script', 'https://cdn.us.zip.co/v1/quadpay.js')
    }, [])
    return <div className={className}>
        <zip-payment-widget amount={orderTotal.amount}/>
    </div>
}